import * as api from '../api.js';
import * as auth from '#actions/auth';

export const updateUserPref = async (
  set,
  get,
  { preference, email, address, firstName, lastName, secondaryPhone }
) => {
  const userId = get().user._id;
  const updatedUser = await api.updateUserPref({
    preference,
    userId,
    email,
    address,
    firstName,
    lastName,
    secondaryPhone,
  });
  if (!updatedUser?._id) {
    return;
  }
  await auth.updateUser(set, get, { user: updatedUser, calle: 'updateUserPref' });
};